module.exports = __webpack_public_path__ + "static/img/9.fdc1604e.jpg";